import React from "react";
import { PreviewResult } from "./LabelAutocomplete";
import LabelSummaryImagePreview, {
  PreviewDialogClasses,
} from "./LabelSummaryImagePreview";

interface Props {
  result: PreviewResult | null;
  isLoading?: boolean;
  showImagePreview?: boolean;
  previewDialogClasses?: PreviewDialogClasses;
}

interface LabelCountEntryProps {
  label: string;
  count: number;
}

const LabelCountEntry = ({ label, count }: LabelCountEntryProps) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 6,      
    }}
  >
    <span
      style={{
        display: "inline-block",
        padding: "2px 7px",
        borderRadius: 3,
        backgroundColor: "rgba(0,123,255,.12)",
        color: "#0056b3",
        fontSize: 12,
        fontWeight: 500,
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
    <span style={{ color: "#555", fontSize: 13 }}>
      {count} image{count !== 1 ? "s" : ""}
    </span>
  </div>
);

const LabelSummary = ({
  result,
  isLoading,
  showImagePreview = false,
  previewDialogClasses,
}: Props) => {
  if (isLoading) {
    return (
      <div
        style={{
          marginTop: 12,
          padding: "10px 14px",
          borderRadius: 4,
          border: "1px solid rgba(72,72,72,.12)",
          backgroundColor: "#f8f9fa",
          fontSize: 14,
          color: "#888",
        }}
      >
        Chargement...
      </div>
    );
  }

  if (!result) return null;

  const { total, countByLabel, images = [] } = result;
  const entries = countByLabel
    ? Object.entries(countByLabel).sort((a, b) => b[1] - a[1])
    : [];

  return (
    <div
      style={{
        marginTop: 12,
        padding: "12px 14px",
        borderRadius: 4,
        border: "1px solid rgba(72,72,72,.12)",
        backgroundColor: "#f8f9fa",
        fontSize: 14,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 12,
      }}
    >
      <div
        style={{
          fontWeight: 600,
          color: "#333",
        }}
      >
        {total} image{total !== 1 ? "s" : ""} correspondent aux critères
      </div>
      {entries.length > 0 && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "4px 16px" }}>
          {entries.map(([label, count]) => (
            <LabelCountEntry key={label} label={label} count={count} />
          ))}
        </div>
      )}
      {showImagePreview && (
        <LabelSummaryImagePreview
          images={images}
          total={total}
          dialogClasses={previewDialogClasses}
        />
      )}
    </div>
  );
};

export default LabelSummary;
